var _rect, _path, _rect2, _path2, _rect3, _path3, _path4, _path5, _rect4, _path6, _path7, _path8, _path9, _rect5, _rect6, _path10, _path11, _path12, _rect7, _rect8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFoundTumbleweed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 274,
    viewBox: "0 0 274 274",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 68.8789,
    y: 132.16,
    width: 10.5969,
    height: 29.2328,
    transform: "rotate(80.4322 68.8789 132.16)",
    fill: "#81CADA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.067 153.362L184.9 157.312L193.649 135.531L237.335 112.187L232.341 102.841L199.794 120.232L204.247 109.145L194.414 105.196L175.067 153.362Z",
    fill: "#3E9CB0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70.7715,
    y: 148.102,
    width: 10.5969,
    height: 44.0962,
    transform: "rotate(44.2519 70.7715 148.102)",
    fill: "#B3DDE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5182 123.27L79.7641 131.436L102.168 149.967L81.6003 153.295L83.2928 163.756L113.023 158.946L134.952 177.085L141.706 168.919L86.5182 123.27Z",
    fill: "#3E9CB0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 147.031,
    y: 236.796,
    width: 10.5969,
    height: 31.6659,
    transform: "rotate(153.667 147.031 236.796)",
    fill: "#60B8CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147.884 197.056L142.542 206.209L183.819 230.301L189.161 221.149L171.016 210.558L187.983 194.365L180.666 186.699L161.492 204.999L147.884 197.056Z",
    fill: "#60B8CB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173.3 185.301L170.584 175.058L163.505 176.935L173.063 167.813L165.746 160.147L142.255 182.568L120.41 188.358L123.125 198.601L173.3 185.301Z",
    fill: "#B3DDE7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M182.129 179.119L191.675 183.72L200.65 165.101L229.961 151.746L225.568 142.103L207.843 150.178L208.918 147.948L199.373 143.346L182.129 179.119Z",
    fill: "#16869E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 99.2422,
    y: 87.0287,
    width: 10.5969,
    height: 41.5641,
    transform: "rotate(-166.207 99.2422 87.0287)",
    fill: "#3E9CB0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4508 121.837L80.4606 118.359L66.8284 79.1234L56.8187 82.601L63.9178 103.034L41.1565 106.446L42.7274 116.926L67.4563 113.218L70.4508 121.837Z",
    fill: "#16869E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.301 91.7376L78.5316 101.966L101.006 108.051L96.8727 116.626L106.418 121.227L124.467 83.7858L114.921 79.1845L105.687 98.34L81.301 91.7376Z",
    fill: "#60B8CB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M135.743 34.3944L125.759 37.9448L133.593 59.9755L110.666 65.9824L113.352 76.2333L137.156 69.9964L145.488 93.4274L155.472 89.8771L135.743 34.3944Z",
    fill: "#B3DDE7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M156.515 60.4312L151.188 69.5918L182.705 87.9191L185.292 95.3666L195.302 91.889L180.767 50.0546L170.757 53.5322L177.367 72.5576L156.515 60.4312Z",
    fill: "#60B8CB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 202.898,
    y: 71.3689,
    width: 10.5969,
    height: 29.56,
    transform: "rotate(8.73931 202.898 71.3689)",
    fill: "#60B8CB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 103.133,
    y: 169.113,
    width: 10.5969,
    height: 19.2878,
    transform: "rotate(8.73931 103.133 169.113)",
    fill: "#16869E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4375 176.336L77.5372 180.114L97.2319 231.719L107.132 227.941L99.0981 206.889L113.833 211.451L116.967 201.328L94.2973 194.31L87.4375 176.336Z",
    fill: "#81CADA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M162.753 158.315L165.886 148.192L152.23 143.964L163.14 137.272L157.599 128.24L138.761 139.795L130.081 137.108L126.947 147.23L162.753 158.315Z",
    fill: "#60B8CB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M174.76 121.451L173.798 110.898L154.9 112.62L137.228 96.5619L130.101 104.405L140.579 113.926L119.702 115.83L120.664 126.383L174.76 121.451Z",
    fill: "#81CADA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 180.549,
    y: 92.2759,
    width: 10.5969,
    height: 17.8445,
    transform: "rotate(93.0404 180.549 92.2759)",
    fill: "#16869E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 72.5215,
    y: 193.404,
    width: 10.5969,
    height: 17.8445,
    transform: "rotate(-173.169 72.5215 193.404)",
    fill: "#60B8CB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundTumbleweed);
export default __webpack_public_path__ + "static/media/not-found-tumbleweed.2b6cc05990778609516362089a5b2526.svg";
export { ForwardRef as ReactComponent };